// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2cQfl","requiredAsterisk":"Info_requiredAsterisk__1G_WD"};